import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";
import {apiClient} from "../connection/BlinkApiClient";

@globalStore
export class SubscriptionBenefit extends BaseStore("SubscriptionBenefit") {
    @field(String) name: string;
    @field(String) description: string;
    @field(String) alias: string;

    toString(): string {
        return this.name;
    }

    serializeForSDK() {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            alias: this.alias,
        }
    }
}

export async function apiMerchantCreateSubscriptionBenefit(request: any): Promise<SubscriptionBenefit> {
    const response = await apiClient.post("/merchant/create_subscription_benefit/", request);
    return SubscriptionBenefit.loadObject(response);
}

export async function apiMerchantEditSubscriptionBenefit(request: any): Promise<any> {
    return apiClient.post("/merchant/edit_subscription_benefit/", request);
}
